module.exports = __webpack_public_path__ + "img/8.f50b5535.jpg";